/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Created_OnInputs */



/**
* | output |
* | --- |
* | "Created On" |
*
* @param {Created_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const created_on = /** @type {((inputs?: Created_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Created_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créé le")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellt am")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creato il")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создано в")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creado el")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建于")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作成日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पर बनाया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criado em")
	return /** @type {LocalizedString} */ ("Created On")
});